import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendQueryStripeInvoicePageArgs,
  BackendStripeInvoicePage,
} from 'src/types/backend';

const QUERY = gql`
  query StripeInvoicePage($stripeInvoiceId: ID!) {
    stripeInvoicePage(stripeInvoiceId: $stripeInvoiceId) {
      url
    }
  }
`;

type Variables = BackendQueryStripeInvoicePageArgs;
type Result = BackendStripeInvoicePage;

export const queryStripeInvoicePage = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
